const INVOICE_DOCUMENT_TYPE_IDS = [1, 27];
const CREDIT_NOTE_DOCUMENT_TYPE_ID = 3;

type MoloniDocument = {
    document_id: number;
    document_type_id: number;
    net_value: number;
    reverse_associated_documents?: Array<MoloniDocument>;
};

export const flattenInvoiceDocuments = (invoiceData: Array<MoloniDocument> | null | undefined) => {
    if (!invoiceData) return [];

    const documentsById = new Map<number, MoloniDocument>();

    invoiceData.forEach((document) => {
        documentsById.set(document.document_id, document);
        document.reverse_associated_documents?.forEach((childDocument) => {
            documentsById.set(childDocument.document_id, childDocument);
        });
    });

    const flattenedDocuments = Array.from(documentsById.values());
    return flattenedDocuments;
};

export const calculateInvoicedNet = (invoiceData: Array<MoloniDocument> | null | undefined) => {
    const allDocuments = flattenInvoiceDocuments(invoiceData);

    const invoicedNet = allDocuments.reduce((total, document) => {
        if (INVOICE_DOCUMENT_TYPE_IDS.includes(document.document_type_id)) {
            return total + (document.net_value || 0);
        }
        if (document.document_type_id === CREDIT_NOTE_DOCUMENT_TYPE_ID) {
            return total - Math.abs(document.net_value || 0);
        }
        return total;
    }, 0);

    return invoicedNet;
};
